import React from "react";
import TimeOffHr from "../components/TimeOffHr/TimeTable";

const TimeOffHrPage = () => {
    return <TimeOffHr />;
};

export default TimeOffHrPage;
